<template>

    <div class="page-alert" :class="classes">
        <div class="page-alert-body">
            <slot></slot>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .page-alert {

        @include font-medium(12px);

        .page-alert-body {
            align-items: center;
            border-radius: 3px;
            display: flex;
            height: 40px;
            padding: 0 30px;
            a {
                color: inherit;
                text-decoration: underline;
            }
        }

        &.page-alert-info .page-alert-body {
            background: rgba($color-primary, 0.05);
            color: $color-primary;
        }
        &.page-alert-success .page-alert-body {
            background: rgba($color-success, 0.05);
            color: $color-success;
        }
        &.page-alert-warning .page-alert-body {
            background: rgba($color-warning, 0.05);
            color: $color-warning;
        }
        &.page-alert-danger .page-alert-body {
            background: rgba($color-danger, 0.05);
            color: $color-danger;
        }

    }

</style>

<script>

export default {

    props: {
        type: {
            type: String,
            default: 'danger',
        },
    },

    computed: {

        classes() {
            return {
                'page-alert-danger': this.type === 'danger',
                'page-alert-warning': this.type === 'warning',
                'page-alert-info': this.type === 'info',
                'page-alert-success': this.type === 'success',
            }
        },

    },

}

</script>